export enum EEMO_ICON_KEY {
  EEMO = 'eemo',
  SEND = 'eemo_send'
}
